import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';

import { CustomForms } from '../forms/custom-forms';
import { AppComponent } from 'src/app/app.component';
import { MainComponent } from '../main/main.component';
import { environment } from 'src/environments/environment';

import { JqWidgets } from 'src/app/utils/jqWidgets';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { jqxWindowComponent } from 'jqwidgets-ng/jqxwindow';

import { NzModalService } from 'ng-zorro-antd/modal';
import { JqxDomService } from 'src/app/services/jqwidgets/jqx-dom.service';
import { CiudadanosService } from 'src/app/services/ciudadanos/ciudadanos.service';

import { CiudadanoModel } from 'src/app/services/ciudadanos/models/ciudadano.model';

import { CiudadanosEditComponent } from './ciudadanos-edit/ciudadanos-edit.component';
import { CiudadanosListadoTarjetasComponent } from './ciudadanos-listado-tarjetas/ciudadanos-listado-tarjetas.component';
import { SsoService } from 'src/app/services/sso/sso.service';

@Component({
  selector: 'app-ciudadanos',
  templateUrl: './ciudadanos.component.html',
  styleUrls: ['./ciudadanos.component.css']
})
export class CiudadanosComponent extends CustomForms implements OnInit {
  @ViewChild('windowCiudadanos') windowCiudadanos: jqxWindowComponent;
  @ViewChild('gridCiudadanos', { static: false }) gridCiudadanos: jqxGridComponent;
  @ViewChild('formCiudadano', { read: ViewContainerRef }) editCiudadanoComponent;

  static _this: any;
  private componentRef = null;
  public environment = environment;
  public langGrid = JqWidgets.getLocalization('es');

  formCiudadano: any;
  private rowIndex = -1;
  ciudadanos: CiudadanoModel[] = [];
  public ciudadanoSelect: CiudadanoModel;

  // Para traducir los textos
  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  constructor(
    private ciudadanosService: CiudadanosService,
    private modal: NzModalService,
    private ssoService: SsoService,
    private jqxDomService: JqxDomService
  ) {
    super();
    CiudadanosComponent._this = this;
  }

  public init(componentRef: any) {
    this.componentRef = componentRef;
  }

  ngOnInit(): void {
    this.langGrid = JqWidgets.getLocalization(this.ssoService.getTicket().Usuario.Idioma.Codigo.substring(0, 2));
    this.initGrid();
  }

  async ngAfterViewInit(): Promise<void> {
    this.addCustomForm(this.windowCiudadanos);

    await this.getCiudadanos();
  }

  public onClose() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }

  /* GRID de ciudadanos */
  /*
    Comprueba si el ciudadano esta validado o no
    y marca el check en la columna correspondiente
  */
  renderValidadoColumn = (row: number, columnfield: string, value: string | number, defaulthtml: string, columnproperties: any, rowdata: any): string => {
    if (value == 1) {
      return '<div class="jqx-grid-cell-left-align" style="margin-top: 4px;">Si</div>';
    }
    else {
      return '<div class="jqx-grid-cell-left-align" style="margin-top: 4px;">No</div>';
    }
  };

  public columnsCiudadanos;

  public sourceCiudadanos;
  public adapterCiudadanos;

  initGrid() {
    this.columnsCiudadanos = [
      { text: 'Id', columntype: 'textbox', datafield: 'id', width: 80, hidden: true },
      { text: this.translate('Validado'), columntype: 'textbox', datafield: 'estadoValidacion', cellsrenderer: this.renderValidadoColumn, width: 'auto' },
      { text: this.translate('Nombre'), columntype: 'textbox', datafield: 'nombre', width: 'auto' },
      { text: this.translate('Apellidos'), columntype: 'textbox', datafield: 'apellidos', width: 'auto' },
      { text: this.translate('Telefono'), columntype: 'textbox', datafield: 'telefono', cellsrenderer: this.numberrenderer, width: 'auto' },
      { text: this.translate('Correo_electronico'), columntype: 'textbox', datafield: 'correoElectronico', width: 'auto' },
      { text: this.translate('Numero_catastro'), columntype: 'textbox', datafield: 'numeroCatastro', width: 'auto' },
      { text: this.translate('Codigo_postal'), columntype: 'textbox', datafield: 'codigoPostal', cellsrenderer: this.numberrenderer, width: 'auto' },
      { text: this.translate('Direccion'), columntype: 'textbox', datafield: 'direccion', width: 'auto' },
      { text: this.translate('Municipio'), columntype: 'textbox', datafield: 'municipio', width: 'auto' },
      { text: this.translate('Provincia'), columntype: 'textbox', datafield: 'provincia', width: 'auto' },
      { text: this.translate('Comunidad_autonoma'), columntype: 'textbox', datafield: 'comunidadAutonoma', width: 'auto' },
      { text: this.translate('Num_tarjetas'), columntype: 'textbox', datafield: 'numeroTarjetas', cellsrenderer: this.numberrenderer, width: 'auto' },
    ]

    this.sourceCiudadanos = {
      datatype: 'json',
      datafields: [
        { name: 'id', type: 'int', map: 'id' },
        { name: 'estadoValidacion', type: 'int', map: 'estadoValidacion' },
        { name: 'nombre', type: 'string', map: 'nombre' },
        { name: 'apellidos', type: 'string', map: 'apellidos' },
        { name: 'telefono', type: 'int', map: 'telefono' },
        { name: 'correoElectronico', type: 'string', map: 'correoElectronico' },
        { name: 'numeroCatastro', type: 'string', map: 'numeroCatastro' },
        { name: 'codigoPostal', type: 'int', map: 'codigoPostal' },
        { name: 'direccion', type: 'string', map: 'direccion' },
        { name: 'municipio', type: 'string', map: 'municipio' },
        { name: 'provincia', type: 'string', map: 'provincia' },
        { name: 'comunidadAutonoma', type: 'string', map: 'comunidadAutonoma' },
        { name: 'numeroTarjetas', type: 'int', map: 'tarjetas>length' }
      ],
      localdata: this.ciudadanos,
      sortcolumn: 'id',
      sortdirection: 'asc'
    }
  }

  async getCiudadanos() {
    this.ciudadanos = await this.ciudadanosService.getCiudadanos();

    if (!this.ciudadanos) {
      this.ciudadanos = [];
    }

    this.sourceCiudadanos.localdata = this.ciudadanos;
    this.adapterCiudadanos = new jqx.dataAdapter(this.sourceCiudadanos);

    setTimeout(() => {
      this.gridCiudadanos.attrColumns.forEach((column: any) => {
        this.gridCiudadanos.autoresizecolumn(column.datafield, column.columntype);
      });
    }, 500);
  }

  /* Acciones del grid */
  onRowClick(event: any) {
    if (this.rowIndex != event.args.rowindex) {
      this.rowIndex = event.args.rowindex;
      this.ciudadanoSelect = this.ciudadanos[event.args.rowindex];
      this.gridCiudadanos.selectrow(this.rowIndex);
    } else if (this.rowIndex === event.args.rowindex) {
      this.gridCiudadanos.unselectrow(this.rowIndex);
      this.rowIndex = null;
      this.ciudadanoSelect = null;
    }
  }

  onRowdoubleclick(event: any) {
    this.rowIndex = event.args.rowindex;
    this.ciudadanoSelect = this.ciudadanos[event.args.rowindex];
    this.gridCiudadanos.selectrow(this.rowIndex);

    this.onEditarCiudadano(event);
  }

  onRowSelect(event: any) {
    this.rowIndex = event.args.rowindex;
    this.ciudadanoSelect = this.ciudadanos[event.args.rowindex];

    if (this.gridCiudadanos.getselectedrowindexes().length > 1) {
      this.gridCiudadanos.clearselection();
      this.gridCiudadanos.selectrow(event.args.rowindex);
    }
  }

  onRowUnselect(event: any) {
    this.rowIndex = null;
    this.ciudadanoSelect = null;
  }

  /* ACCIONES DE LOS BOTONES INFERIORES */

  public onCrearCiudadano(event: any){
    this.windowCiudadanos.collapse();

    this.formCiudadano = this.editCiudadanoComponent.createComponent(CiudadanosEditComponent);
    this.formCiudadano.instance.init(this.formCiudadano);
  }

  public onEditarCiudadano(event: any){
    /*
      Comprueba si se tiene seleccionado un ciudadano
      para editar sus datos, en caso contrario muestra
      un mensaje de error
    */
    if (this.ciudadanoSelect) {
      this.windowCiudadanos.collapse();

      this.formCiudadano = this.editCiudadanoComponent.createComponent(CiudadanosEditComponent);
      this.formCiudadano.instance.init(this.formCiudadano, this.ciudadanoSelect);
    } else {
      MainComponent.getInstance().showWarning('ATENCION', 'Seleccione_registro', 2000);
    }
  }

  /* Muestra la confirmación del borrado */
  public onBorrarCiudadano(event: any){
    /*
      Comprueba si se tiene seleccionado un ciudadano
      para borrarlo, en caso contrario muestra
      un mensaje de error
    */
    if (this.ciudadanoSelect) {
      this.modal.confirm({
        nzTitle: '<i>' + this.translate('ATENCION') + '</i>',
        nzContent: this.translate('Quiere_borrar_ciudadano'),
        nzCentered: true,
        nzCancelText: this.translate('CANCELAR'),
        nzOkText: this.translate('SI'),
        nzOnOk: async () => {
          this.removeCiudadano();
          this.modal.closeAll();
        }
      });
    } else {
      MainComponent.getInstance().showWarning('ATENCION', 'Seleccione_registro', 2000);
    }
  }

  /* Metodo que se llama al confirmar el borrado */
  async removeCiudadano() {
    if (await this.ciudadanosService.deleteCiudadano(this.ciudadanoSelect.id)) {
      this.ciudadanos.splice(this.ciudadanos.indexOf(this.ciudadanoSelect), 1);

      this.adapterCiudadanos = new jqx.dataAdapter(this.sourceCiudadanos);
      this.gridCiudadanos.unselectrow(this.rowIndex);

      MainComponent.getInstance().showInfo(
        'ATENCION',
        'Registro_borrado',
        2000
      );
    } else {
      MainComponent.getInstance().showWarning(
        'Error',
        'Error_api',
        2000
      );
    }
  }
  /* FIN ACCIONES BOTONES INFERIORES */

  /*
    Muestra el listado de tarjetas asociadas a un ciudadano
  */
  rowdetailstemplate: any = {
    rowdetails: '<div id="nestedGrid"></div>',
    rowdetailshidden: true,
    rowdetailsheight: 250,
  };

  initRowDetails = (
    index: number,
    parentElement: any,
    gridElement: any,
    record: any
  ): void => {
    if (parentElement) {
      let tarjetas = this.ciudadanos[index].tarjetas;
      const container = document.createElement('div');
      parentElement.appendChild(container);
      const component: any =
        CiudadanosComponent._this.jqxDomService.loadComponent(
          CiudadanosListadoTarjetasComponent,
          container
        );
      component.componentRef.instance.init(component, tarjetas);
    }
  }

  // Renderizado de numeros en el grid
  numberrenderer(
    row: number,
    columnfield: string,
    value: any,
    defaulthtml: string,
    columnproperties: any,
    rowdata: any
  ): string {
    if (value) {
      return (
        '<div class="jqx-grid-cell-right-align" style="margin-top: 4px;">'
        + value.toString() +
        '</div>'
      );
    } else if (value === 0) {
      return (
        '<div class="jqx-grid-cell-right-align" style="margin-top: 4px;">'
        + value.toString() +
        '</div>'
      );
    }
  }

  onRowExpand(event: any) {
    const args = event.args;
    const rowBoundIndex = args.rowindex;
    setTimeout(() => {
      this.gridCiudadanos.scrolloffset(rowBoundIndex * this.gridCiudadanos.rowsheight(), 0);
    }, 250);
  }
}
